/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Audit_FactsInputs */

const en_directory_agent_readiness_audit_facts = /** @type {(inputs: Directory_Agent_Readiness_Audit_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit details`)
};

const zh_directory_agent_readiness_audit_facts = /** @type {(inputs: Directory_Agent_Readiness_Audit_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审计信息`)
};

/**
* | output |
* | --- |
* | "Audit details" |
*
* @param {Directory_Agent_Readiness_Audit_FactsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_audit_facts = /** @type {((inputs?: Directory_Agent_Readiness_Audit_FactsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Audit_FactsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_audit_facts(inputs)
	return zh_directory_agent_readiness_audit_facts(inputs)
});
export { directory_agent_readiness_audit_facts as "directory.agent_readiness.audit_facts" }